export default {
  key: 'emoji',
  name: 'Emoji',
  description: '',
  value: true,
  options: [
    { key: 'emoji', type: 'text', placeholder: 'Put an Emoji', value: '' }
  ]
}
